<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cXjZVE/images/9781439655528.jpg?1684515197906" alt="This image is the cover for the book Lincoln County, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lincoln County, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>On April 7, 1870, an act of the state legislature created Lincoln County, named for Pres. Abraham Lincoln, from Lawrence, Franklin, Copiah, Pike, and Amite Counties. Settlement began more than 50 years earlier with Samuel Jayne's small trading post on St. Stephens Road. Extensive timber resources, the arrival of the railroad in 1857, and the 1859 founding of Whitworth Female College put the county on the map. Logging, lumber mills, and other industries brought scores of people to the region. The agricultural endeavors of cotton and farming provided a way of life before the oil boom of the 1940s. The varied ethnic and religious history of the residents further shaped the county into what exists today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tammie Santos Brewer, Bettie P. Bullard, Sue Dorman, Marti Parker
      </h2>
      
      <p class="authorDescription body article">Tammie Santos Brewer, former newspaper and graphics editor; Bettie P. Bullard, former college professor and retired teacher of gifted education; Sue Dorman, local historian; and Marti Parker, retired school librarian, have spent many hours compiling this collection of images. They procured photographs from local and state archives--including the John Holly Williams Collection and the Jackson Studio Collection in the Lincoln-Lawrence-Franklin Regional Library and the Mississippi Department of Archives and History--in addition to private collections in order to reflect the spirit of the community.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?497f4812